"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoAction = exports.Placement = exports.ContentType = void 0;
/**
 * Specific values of placements in various sections.
 * Re-use existing values if possible. Add new values here when needed.
 * Please, add description of new placements into README.md docs.
 */
let Placement = exports.Placement = /*#__PURE__*/function (Placement) {
  /** Section with products added to order without cost in Product listing in basket page. */
  Placement["AddedFree"] = "added free";
  /** Section with products added to order with cost in Product listing in basket page. */
  Placement["AddedWithCost"] = "added with cost";
  /** Live Shopping (Bambuser) video component. Available in multiple Online pages when switched on. */
  Placement["BambuserVideo"] = "bambuser-video";
  /** Beauty edit banner section of Online Front Page 3.0. */
  Placement["BeautyEditBanner"] = "beauty edit banner";
  /** Offers product listing in Beauty Rewards page, the Rewards tab. */
  Placement["BeautyRewardsOffers"] = "beauty rewards offers";
  /** Best Offers section of Online Front Page 3.0 and 2.0. */
  Placement["BestOffersProducts"] = "best offers products";
  /** Campaign Banner section of Online Front Page 3.0. */
  Placement["CampaignBanner"] = "campaign banner";
  /** Category Listing section of Online Front Page 3.0. */
  Placement["CategoryListing"] = "category listing";
  /** Category banners */
  Placement["CategoryInFocus"] = "category in focus";
  /** Constant benefit banner (Top of Hero banner) */
  Placement["ConstantBenefitBanner"] = "Constant benefit banner";
  /** Section with orders made by customers in Product listing in basket page. */
  Placement["CustomerOrders"] = "customer orders";
  /** Digital Catalogue in Online. */
  Placement["DigitalCatalogue"] = "digital catalogue";
  /** Digital Catalogue iPaper. */
  Placement["DigitalCatalogueECatalogue"] = "digital catalogue - eCatalogue";
  /** Favorite / Wishlist Products popup section of Online Top Navigation 3.0. */
  Placement["FavoritesSubmenu"] = "favorites submenu";
  /**
   * Used in Subscription Wizard app integration in ASMS as a fallback value
   * when no placement is found in serialized root element's data for the app.
   * That seems to be the case for example for PDP and probably other pages.
   */
  Placement["FloatingMenu"] = "floating-menu";
  /** Gift cards page / section in mypages, where brand partner can see available gift cards list and share it. */
  Placement["GiftCards"] = "gift cards";
  /** Hero (main top) banner in Online Front Page 3.0 and 2.0. */
  Placement["HeroBanner"] = "hero banner";
  /** Section for registration and upgrade */
  Placement["JoinUs"] = "join us";
  /** LookBook section of Online Front Page 3.0. */
  Placement["LookbookBanner"] = "lookbook banner";
  /** Lookbook */
  Placement["Lookbook"] = "lookbook";
  /** Main section of Product listing in basket page. */
  Placement["MainBasket"] = "main basket";
  /** Main product section in Product Detail Page 2.0 and newer. */
  Placement["MainProductDetail"] = "main product detail";
  /** Minibag v2. */
  Placement["Minibag"] = "minibag";
  /** Mobile office promo popup banner. */
  Placement["MobileOfficePromoPopup"] = "mobile office - promo popup";
  /** Mobile office whats new banner. */
  Placement["MobileOfficeWhatsNew"] = "mobile office - whats new";
  /** What's New / New Products section in Online Front Page 3.0 and 2.0. */
  Placement["NewProducts"] = "new products";
  /** Offer Hints section in basket page. */
  Placement["OfferHints"] = "offer hints";
  /** Checkout and shipping offers section in Product listing in basket page. */
  Placement["Offers"] = "offers";
  /** Product list in Olapic widget details. */
  Placement["OlapicWidget"] = "olapic widget";
  /**  */
  Placement["OnBehalf"] = "on behalf";
  /**  */
  Placement["OtherProducts"] = "other products";
  /** Personalised nutrition products added through repurchase banner in order detail */
  Placement["PersonalisedNutrition"] = "personalised nutrition";
  /** Personal Product Listing page, placement for the product boxes part. */
  Placement["PersonalProductList"] = "personal product list";
  /** Personal Product Listing page, placement for the additional buy-all button (same add-to-basket event triggered here). */
  Placement["PersonalProductListBuyAll"] = "personal product list - buy all button";
  /** Product Detail Page. */
  Placement["ProductDetail"] = "product detail";
  /** A generic fallback value which is enough to use when only 1 product listing instance can be present in current page. */
  Placement["ProductListing"] = "product listing";
  /** A generic fallback value for case when only 1 product slider instance can be present in current page. */
  Placement["ProductSlider"] = "product slider";
  /** Quickbuy button on Product Listing Page. */
  Placement["QuickbuyPLP"] = "quickbuy-plp";
  /** Quickbuy button on Search Results Page and on Search Results Preview. */
  Placement["QuickbuySearch"] = "quickbuy-search";
  /** Quickbuy button on eCatalogue Page. */
  Placement["QuickbuyECatalogue"] = "quickbuy-eCatalogue";
  /** Quickbuy button on Shopping Basket Page. */
  Placement["QuickbuyBasket"] = "quickbuy-basket";
  /** Quick Order Form component in basket page. */
  Placement["QuickOrderForm"] = "quick order form";
  /** Parcel tracking (Real Time Order Tracking) on Order Detail Page */
  Placement["RealTimeOrderTracking"] = "real time order tracking";
  /** Recently Viewed Products slider instance in Product Detail Page and other places. */
  Placement["RecentProducts"] = "recent products";
  /** Recommended Products section in Online Front Page 2.0. Not present on FP 3.0 yet. */
  Placement["RecommendedProducts"] = "recommended products";
  /** Related Products slider instance in Product Detail Page and other places. */
  Placement["RelatedProducts"] = "related products";
  /** From Revieve quiz result. */
  Placement["Revieve"] = "revieve";
  /** From Revieve Skin Diagnosis quiz result. */
  Placement["RevieveSkinDiagnosis"] = "skindiagnosis";
  /** From Revieve Foundation Finder quiz result. */
  Placement["RevieveFoundationFinder"] = "foundationfinder";
  /** From Revieve Virtual Try-On result. */
  Placement["RevieveVirtualTryOn"] = "virtualtryon";
  /** From Revieve Virtual Try-On PDP result. */
  Placement["RevieveVirtualTryOnPDP"] = "virtualtryonPDP";
  /** Reward Shop section in a new Front Page (in MV7 only so far) */
  Placement["RewardShop"] = "reward shop";
  /** Sample products slider instance in basket page. */
  Placement["Samples"] = "samples";
  /** Category Listing section of Online Front Page 3.0. */
  Placement["SelectedCategoryProducts"] = "selected category products";
  /** Search Suggestions on Search Results Page */
  Placement["SearchSuggestions"] = "search suggestions";
  /** Registration Form for anonymous users. */
  Placement["SelfRegistrationForm"] = "self-registration form";
  /** Product Set Section in Product Detail Page. */
  Placement["SetSection"] = "set section";
  /** Similar Products section in Product Detail Page. and other places. */
  Placement["SimilarProducts"] = "similar products";
  /** Registration Form where sponsor can register another user. */
  Placement["SponsorRegistrationForm"] = "sponsor registration form";
  /** Compatibility value for older Online views. Can probably be replaced with 'subscriptions' later. */
  Placement["SubscriptionButton"] = "subscription-button";
  /** Section with subscriptions in Product listing in basket page. */
  Placement["Subscriptions"] = "subscriptions";
  /** Top Brands section of Online Front Page 3.0. */
  Placement["TopBrands"] = "top brands";
  /** Category navigation section of Online Front Page 3.0. */
  Placement["TopCategories"] = "top categories";
  /** Popular Products section in Top Navigation 3.0. */
  Placement["TopNavigationPopularProducts"] = "top navigation popular products";
  /** Search Suggestions section in Top Navigation 3.0. */
  Placement["TopNavigationSearchSuggestions"] = "top navigation search suggestions";
  /** Shop For section in Top Navigation 3.0. */
  Placement["TopNavigationShopFor"] = "top navigation shop for";
  /** The Transition Box component offers a customer the latest version of the product originally wanted. Used in PDP. */
  Placement["TransitionBox"] = "transition box";
  /** From typeform quiz result. */
  Placement["Typeform"] = "typeform";
  /** Vip benefits section of Online Front Page 3.0. */
  Placement["VipCustomerBenefits"] = "vip customer benefits";
  /** Registration Form in basket page. */
  Placement["VipCustomerCheckoutRegistrationForm"] = "checkout registration form";
  return Placement;
}({});
/**
 * Generic product metadata shared across all
 * analytics or extended custom events.
 */
/**
 * Generic banner metadata shared across all
 * analytics or extended custom events.
 */
/**
 * Generic positioning metadata shared across all
 * analytics or extended custom events.
 */
/**
 * Specific values of shared content category.
 * Re-use existing values if possible. Add new values here when needed.
 */
let ContentType = exports.ContentType = /*#__PURE__*/function (ContentType) {
  ContentType["Article"] = "article";
  ContentType["Catalogue"] = "catalogue";
  ContentType["GiftCard"] = "gift card";
  ContentType["Page"] = "page";
  ContentType["Photo"] = "photo";
  ContentType["PopularQuery"] = "popular query";
  ContentType["Product"] = "product";
  ContentType["ProductList"] = "product list";
  return ContentType;
}({});
/**
 * Analytics metadata extension for add-to-basket custom event.
 */
/** Analytics metadata extension for remove-basket-item custom event. */
/**
 * Analytics metadata extension for update-basket-item custom event.
 */
/**
 * Specific values of actions on video.
 * Re-use existing values if possible. Add new values here when needed.
 */
let VideoAction = exports.VideoAction = /*#__PURE__*/function (VideoAction) {
  VideoAction["Start"] = "start";
  VideoAction["Progress"] = "progress";
  VideoAction["Complete"] = "complete";
  return VideoAction;
}({});
//# sourceMappingURL=index.js.map